import { createSelector } from 'reselect';

const containerSelector = createSelector([
  (store) => store.apps.jobs,
  (store, props) => props.match.params.username,
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
  (store, props) => props.isSubaccountDashboard,
],
(jobs, username, isOpenSauceUser, user, isSubaccountDashboard) => ({
  buildsLoading: jobs.flatBuilds.get('buildsLoading'),
  filters: jobs.filters,
  filtersInitialized: jobs.filters.get('filtersInitialized'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingEnabled: jobs.users.get('user').organization.settings ?
    jobs.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  jobsTeamSharingFeatureEnabled: !isOpenSauceUser,
  organizationId: jobs.users.get('user').organization.id || user.organization.id,
  orgTeams: jobs.filters.get('orgTeams'),
  orgUsers: jobs.filters.get('orgUsers'),
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  user: jobs.users.get('user'),
  username: username || jobs.users.get('user').username,
}));

const automatedBuildsSelector = createSelector([
  (store) => store.apps.jobs,
],
(jobs) => ({
  builds: jobs.flatBuilds.get('builds'),
  buildsLoading: jobs.flatBuilds.get('buildsLoading'),
  expandedBuilds: jobs.flatBuilds.get('expandedBuilds'),
  failedJobs: jobs.flatBuilds.get('failedJobs'),
}));

export default containerSelector;
export { automatedBuildsSelector, containerSelector };
